import { ChevronLeft, ChevronRight } from "lucide-react";

export default function WishlistPagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  return (
    <nav className="flex items-center justify-center gap-2" aria-label="Wishlist pagination">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="inline-flex size-10 items-center justify-center rounded-full border border-border disabled:opacity-40"
      >
        <ChevronLeft className="size-4" />
      </button>

      <span className="px-4 text-sm text-muted-foreground">
        {page} / {totalPages}
      </span>

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="inline-flex size-10 items-center justify-center rounded-full border border-border disabled:opacity-40"
      >
        <ChevronRight className="size-4" />
      </button>
    </nav>
  );
}